<template>

            <tr>
              <td style="text-align: left; width: 70%;padding-right: 20px;">{{this.item_name}}</td>
              <td style="text-align: right; width: 20%;padding-right: 20px;">{{this.barcode}}</td>
              <td style="text-align: right; width: 10%;">{{ parseFloat(this.standard_rate).toFixed(2) }}</td>
            </tr>

</template>
<script>

export default {
    name:"FoundProducts",
    data: function(){
        return {
        }
    },    
    methods:{
    },

  props: {
    index: {
        type:Number,
        required:true
    },          
    item_name: {
        type:String,
        required:true
    },
    item_code: {
        type:String,
        required:true
    },
    barcode: {
        type:String,
        required:true
    },    
    standard_rate: {
        type:String,
        required:true
    },    
    new_standard_rate: {
        type:String,
        required:true
    },    
    updatedPointer: {
        type:Boolean,
        required:true
    },    
    
  },
//  emits: ['remove', 'updateProductPrice']
}
</script>

<style scoped>
.grid-container-element { 
    display: grid; 
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}
</style>